import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GoogleMapComponent } from "../../google-map/google-map.component";
import { APIService } from '../../fleet-management/backend-service/backend-service';
import { SharedService } from '../../share-data/shared.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import { NotificationService } from '../../shared/services/notification.service';
import { LoadingService } from '../../services/loading.service';
import { Subscription } from 'rxjs';
import { PhoneFormatDirective } from '../../shared/directives/phone-format.directive';
import { PhoneFormatPipe } from '../../shared/pipes/phone-format.pipe';

@Component({
  selector: 'app-consignee-registration-form',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatInputModule,
    CommonModule,
    MatChipsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatIconModule,
    GoogleMapComponent,
    RouterLink,
    MatProgressSpinnerModule,
    PhoneFormatDirective,
    PhoneFormatPipe
  ],
  templateUrl: './consignee-registration-form.component.html',
  styleUrl: './consignee-registration-form.component.scss'
})
export class ConsigneeRegistrationFormComponent implements OnDestroy {
  nameValue: string = '';
  address: string = '';
  location: string = '';
  remark: string = '';
  contactName: string = '';
  primaryContact: string = '';
  secondaryContact: string[] = [];
  phoneForm!: FormGroup;
  currentLocation: google.maps.LatLngLiteral | null = null;
  userData: any;
  isEdit: string = '';
  isLoading: boolean = false;
  private loadingSubscription: Subscription;

  branchAddress: string = '';
  branchContacts = [{ name: '', phone: '', position: '' }];
  branchLocation: google.maps.LatLngLiteral | null = null;
  selectedBranchIndex: number = -1;

  // Add branches array to store multiple branches
  branches: any[] = [];
  allOriginBranches: any[] = [];
  contacts = [
    { name: '', phone: '', position: '' }
  ];

  constructor(private fb: FormBuilder, private router: Router, private cdr: ChangeDetectorRef, private apiService: APIService, private sharedService: SharedService, private route: ActivatedRoute,
    private notification: NotificationService, public loadingService: LoadingService) {
    this.phoneForm = this.fb.group({
      phoneNumbers: this.fb.array([this.createPhoneNumberField()]), // Start with one field
    });
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(loading => this.isLoading = loading);
  }


  get phoneNumbers(): FormArray {
    return this.phoneForm.get('phoneNumbers') as FormArray;
  }

  createPhoneNumberField(): FormGroup {
    return this.fb.group({
      number: ['', [Validators.required, Validators.pattern(/^\d+$/)]], // Only numbers allowed
    });
  }

  addPhoneNumber(): void {
    this.phoneNumbers.push(this.createPhoneNumberField());
    this.cdr.detectChanges();
  }

  removePhoneNumber(index: number): void {
    if (this.phoneNumbers.length > 1) {
      this.phoneNumbers.removeAt(index);
    }
  }

  handleMapClick(marker: any) {
    console.log("Consignee => Lat: ", marker.latLng.lat(), " Long: ", marker.latLng.lng())
    this.currentLocation = marker.latLng
  }

  handleLocationChanged(newLocation: google.maps.LatLngLiteral) {
    // Handle the new location received from the child component
    this.currentLocation = newLocation;
    console.log('Location received in parent:', this.currentLocation);
  }
  addContact() {
    this.contacts.push({ name: '', phone: '', position: '' });
  }

  removeContact(index: number) {
    if (this.contacts.length > 1) {
      this.contacts.splice(index, 1);
    }
  }

  addBranchBtnAction() {
    // Basic validation for branch data
    if (this.address.length < 1) {
      this.notification.warning('Please enter Address for the branch');
      return;
    }

    if (this.contacts[0].name.length < 1) {
      this.notification.warning('Please enter at least one contact for the branch');
      return;
    }

    // if (!this.currentLocation) {
    //   this.notification.warning('Please select a location on the map for the branch');
    //   return;
    // }
    this.currentLocation = this.currentLocation || { lat: 0, lng: 0 }; // Default to (0,0) if not set

    // Create branch data object
    const branchData = {
      address: this.address,
      locationPin: this.currentLocation.lat + "," + this.currentLocation.lng,
      isDefault: true,
      contacts: this.contacts.map(contact => ({
        contactName: contact.name,
        phoneNumber: contact.phone,
        position: contact.position
      }))
    };
    this.branches.push(branchData);

    // Show success alert
    // window.alert("New branch added successfully!");

    // Log the branch data (you can process this data as needed)
    console.log("Branch Array:", this.branches);

    // Optional: Clear the branch form fields after adding
    this.clearBranchFields();
  }

  // Helper method to clear branch-specific fields
  private clearBranchFields() {
    this.address = '';
    this.currentLocation = null;
    this.contacts = [{ name: '', phone: '', position: '' }];
  }
  onBranchRowClick(branchData: any, index: number) {
    console.log('Branch row clicked:', branchData, index);
    this.branches = [];
    for (let i = 0; i < this.allOriginBranches.length; i++) {
      if (branchData.id != this.allOriginBranches[i].id) {
        this.selectedBranchIndex = i; // Set the selected branch index
        this.address = branchData.address || '';
        if (this.userData.locations[index].locationPin) {
          const locationParts = this.userData.locations[index].locationPin.split(",");
          if (locationParts.length === 2) {
            this.currentLocation = {
              lat: parseFloat(locationParts[0]),
              lng: parseFloat(locationParts[1])
            };
          }
        }
        this.currentLocation = {
          lat: parseFloat(this.allOriginBranches[i].locationPin.split(",")[0]),
          lng: parseFloat(this.allOriginBranches[i].locationPin.split(",")[1])
        };
        this.contacts = branchData.contacts.map((contact: any) => ({
          name: contact.contactName || '',
          phone: contact.phoneNumber || '',
          position: contact.position || ''
        }));


        this.branches.push({
          id: this.allOriginBranches[i].id || '',
          address: this.allOriginBranches[i].address || '',
          locationPin: this.allOriginBranches[i].locationPin || '',
          notes: this.allOriginBranches[i].notes || '',
          isDefault: this.allOriginBranches[i].isDefault || false,
          isActive: this.allOriginBranches[i].isActive || false,
          contacts: this.allOriginBranches[i].contacts.map((contact: any) => ({
            contactName: contact.contactName || '',
            phoneNumber: contact.phoneNumber || '',
            position: contact.position || ''
          })),
        });
        console.log("Selected Branch: ", this.address, this.currentLocation, this.contacts);

      }
    }
  }

  submitButtonAction() {
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    if (this.address.length > 0 && this.contacts.length > 0) {
      this.currentLocation = this.currentLocation || { lat: 0, lng: 0 };
      const branchData = {
        address: this.address,
        locationPin: this.currentLocation.lat + "," + this.currentLocation.lng,
        isDefault: false,
        contacts: this.contacts.map(contact => ({
          contactName: contact.name,
          phoneNumber: contact.phone,
          position: contact.position
        }))
      };
      this.branches.push(branchData);
    }

    // this.secondaryContact = [];

    // const phoneNumbersArray = this.phoneNumbers.controls.map(group => group.get('number')?.value);
    // if (phoneNumbersArray.length > 0) {
    //   this.primaryContact = phoneNumbersArray[0];
    //   if (phoneNumbersArray.length > 1) {
    //     let index = 0;
    //     phoneNumbersArray.forEach(phone => {
    //       if (index > 0) {
    //         this.secondaryContact.push(phone)
    //       }
    //       index++;
    //     });
    //   }
    // }
    if (this.nameValue.length < 1) {
      this.notification.warning('Please enter Consignee Name')
      return;
    }
    let jsonData = {
      // "name": this.nameValue,
      // "address": this.address,
      // "locationPin": this.currentLocation?.lat + "," + this.currentLocation?.lng,
      // "remark": this.remark,
      // "contactName": this.contactName,
      // "primaryContact": this.primaryContact,
      // "secondaryContact": this.secondaryContact.join(','),
      // "status": "active"
      "name": this.nameValue,
      "remark": this.remark,
      "locations": this.branches,
    }
    console.log("Consignee data: ", JSON.stringify(jsonData));
    let endpoint = '';
    if (this.isEdit == 'true') {
      endpoint = '/api/consignees/' + this.userData["id"];
      this.apiService.put(endpoint, jsonData, loginData.token)
        .subscribe({
          next: (response: HttpResponse<any>) => {
            console.log('HTTP Status:', response.status); // 👈 here you get status
            console.log('/api/consignees/edit' + ',\n' + 'Edit_Response:', response.body);

            if (response.status === 200) {
              this.notification.success('Update Consignee successfully');
            }
            else {
              this.notification.error('Update Consignee failed. Please try again.');
            }
            this.router.navigate(['/home/consignee-registration']);
          },
          error: err => {
            console.error('Error:', err);
          }
        });
    }
    else {
      endpoint = '/api/consignees/register';
      this.apiService.post(endpoint, jsonData, loginData.token)
        .subscribe({
          next: (response) => {
            console.log('HTTP Status:', response.status); // 👈 Get status here
            console.log('Response Body:', response.body);
            if (response.status === 200 || response.status === 201) {
              this.notification.success('Register Consignee successfully');
            }
            else {
              this.notification.error('Register Consignee failed. Please try again.');
            }
            this.router.navigate(['/home/consignee-registration']);
          },
          error: (err) => {
            console.error('Error Status:', err.status);    // 👈 Also available on error
            console.error('Error Message:', err.error);
          }
        });

    }
    console.log("endpoint: ", endpoint)

  }
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.isEdit = params["isEdit"];
      if (this.isEdit == 'true') {
        try {
          this.userData = this.sharedService.getData();
          console.log("Share data:", this.userData);
          this.nameValue = this.userData["name"];
          this.remark = this.userData["remark"];
          this.contactName = this.userData["contactName"] ?? null;
          this.primaryContact = this.userData["primaryContact"] ?? null;
          this.secondaryContact = this.userData["secondaryContact"]?.split(',') || [];
          this.phoneNumbers.clear();

          // Add primary contact
          if (this.primaryContact && this.primaryContact.length > 7) {
            this.phoneNumbers.push(this.fb.group({
              number: [this.primaryContact, [Validators.required, Validators.pattern(/^\d+$/)]]
            }));
          }
          for (const phone of this.secondaryContact) {
            if (phone.length > 7) {
              this.phoneNumbers.push(this.fb.group({
                number: [phone.trim(), [Validators.required, Validators.pattern(/^\d+$/)]]
              }));
            }
          }

          // Map contacts array
          if (this.userData["locations"] && this.userData["locations"].length > 0) {
            for (let index = 0; index < this.userData["locations"].length; index++) {
              this.allOriginBranches.push({
                id: this.userData.locations[index].id || '',
                address: this.userData.locations[index].address || '',
                locationPin: this.userData.locations[index].locationPin || '',
                notes: this.userData.locations[index].notes || '',
                isDefault: this.userData.locations[index].isDefault || false,
                isActive: this.userData.locations[index].isActive || false,
                contacts: this.userData.locations[index].contacts.map((contact: any) => ({
                  contactName: contact.contactName || '',
                  phoneNumber: contact.phoneNumber || '',
                  position: contact.position || ''
                })),
              });

              if (index == this.userData["locations"].length - 1) {
                this.selectedBranchIndex = index; // Set the selected branch index to the last one
                this.address = this.userData.locations[index].address || '';
                this.contacts = this.userData.locations[index].contacts.map((contact: any) => ({
                  name: contact.contactName || '',
                  phone: contact.phoneNumber || '',
                  position: contact.position || ''
                }));
                if (this.userData.locations[index].locationPin) {
                  const locationParts = this.userData.locations[index].locationPin.split(",");
                  if (locationParts.length === 2) {
                    this.currentLocation = {
                      lat: parseFloat(locationParts[0]),
                      lng: parseFloat(locationParts[1])
                    };
                  }
                  console.log("Current Location: ", this.currentLocation);
                }
              }
              else {
                this.branches.push({
                  id: this.userData.locations[index].id || '',
                  address: this.userData.locations[index].address || '',
                  locationPin: this.userData.locations[index].locationPin || '',
                  notes: this.userData.locations[index].notes || '',
                  isDefault: this.userData.locations[index].isDefault || false,
                  isActive: this.userData.locations[index].isActive || false,
                  contacts: this.userData.locations[index].contacts.map((contact: any) => ({
                    contactName: contact.contactName || '',
                    phoneNumber: contact.phoneNumber || '',
                    position: contact.position || ''
                  })),
                });
              }
            }
          } else {
            // Ensure at least one empty contact if no contacts exist
            this.branches = [{
              id: '',
              address: '',
              locationPin: '',
              notes: '',
              isDefault: true,
              isActive: true,
              contacts: [{ name: '', phone: '', position: '' }]
            }];
          }

          this.cdr.detectChanges(); // Ensure changes are reflected
        } catch (error) {

        }
      }
    });


  }

  ngOnDestroy() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }
}
